import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-open-notification',
    template: `
        <div class="d-flex flex-row gap-1">
            <button
                class="d-flex gap-2 align-items-center action-button"
                (click)="onOpen()"
            >
                <img class="icon" src="assets/icon/open.png">
                {{ 'notification.open' | translate }}
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `
    ]
})
export class OpenNotificationComponent extends BaseComponent {
    @Output()
    emitter = new Subject<any>();

    @Input()
    data: any = {};

    ngOnInit() { }

    onOpen() {
        this.emitter.next(this.data);
    }
}
